// extracted by css-extract-rspack-plugin
export default {"container":"src-domain-components-logical-device-firmware-card-logicalDeviceFirmwareCard-module__container-CLoh1K","textContainer":"src-domain-components-logical-device-firmware-card-logicalDeviceFirmwareCard-module__textContainer-kebPHS","label":"src-domain-components-logical-device-firmware-card-logicalDeviceFirmwareCard-module__label-uwW3W2"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-domain-components-logical-device-firmware-card-logicalDeviceFirmwareCard-module__container-CLoh1K\",\"textContainer\":\"src-domain-components-logical-device-firmware-card-logicalDeviceFirmwareCard-module__textContainer-kebPHS\",\"label\":\"src-domain-components-logical-device-firmware-card-logicalDeviceFirmwareCard-module__label-uwW3W2\"}";
        // 1793705033102
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  